import configEntzy from "components/config/ConfigEntzy";
import { serviceLogError } from "services/graphql/call";

export const parseValueToInt = function (val, fallback = 0) {
  try {
    return parseInt(val);
  } catch (error) {
    const logCapture = { val, error };
    serviceLogError("parseValueToInt", logCapture);
    return fallback;
  }
};

export const parseEntzyUrl = function (val) {
  try {
    let urlparts = ("/" + val).split("/");
    const eventUrl = urlparts[urlparts.length - 1].toLowerCase();
    return eventUrl;
  } catch (error) {
    const logCapture = { val, error };
    serviceLogError("parseEntzyUrl", logCapture);
    return false;
  }
};
export const parseEntzyLinkToDataUrl = function (val) {
  try {
    // given val pasted by user as url link need to strip any http or https and host parts and extract data url part
    // e.g. https://<env domain or local entzy.com>/country/eventuatorname -> country.eventuatorname
    let urlparts = ("/" + val).split("/");
    let name = urlparts[urlparts.length - 1].toLowerCase();
    let country = urlparts.length > 2 ? urlparts[urlparts.length - 2] : "e";
    return {
      name: name,
      country: country,
      dataUrl: country + "." + name,
    };
  } catch (error) {
    const logCapture = { val, error };
    serviceLogError("parseEntzyLinkToDataUrl", logCapture);
    return {
      name: "",
      country: "e",
      dataUrl: "",
    };
  }
};

export const parseEntzyUrlComponents = function (val) {
  try {
    if (val.indexOf(".") > -1 && val.indexOf("/") === -1) {
      val = val.replace(".", "/");
    }
    if (val.indexOf(".") === -1 && val.indexOf("/") === -1) {
      val = "/e/" + val;
    }

    let urlparts = ("/" + val).split("/");
    let name = urlparts[urlparts.length - 1].toLowerCase();
    let country = urlparts.length > 2 ? urlparts[urlparts.length - 2] : "e";

    if (country.length > 2) {
      country = "e";
    }
    return {
      name: name,
      country: country,
      dataUrl: country === "e" ? name : country + "." + name,
      pointer: "/" + country + "/",
      relativeUrl: "/" + country + "/" + name,
      absoluteUrl: `${configEntzy.APP_URL}/${country}/${name}`,
    };
  } catch (error) {
    const logCapture = { val, error };
    serviceLogError("parseEntzyUrlComponents", logCapture);
    return {
      name: "",
      country: "e",
      dataUrl: "",
      pointer: "/e/",
      relativeUrl: "/e/",
      absoluteUrl: `${configEntzy.APP_URL}/e/`,
    };
  }
};

export const jsonTryParse = function (str, fallback) {
  try {
    return JSON.parse(str);
  } catch (error) {
    const logCapture = { str, error };
    serviceLogError("jsonTryParse", logCapture);
    return fallback ? fallback : [];
  }
};

// url handling
export const getDomainFromUrl = function (url) {
  let domain;
  try {
    if (!url.toLowerCase().startsWith("http")) {
      url = "https://" + url;
    }
    domain = new URL(url);
    domain = domain.hostname
      .toLowerCase()
      .replace("www.", "")
      .substring(url, 20);
  } catch (e) {
    const logCapture = { url, error: e };
    serviceLogError("getDomainFromUrl", logCapture);
    domain = url.substring(url, 20);
  }
  return domain;
};

// currencies
export const getCurrencyDisplayAmount = (intValue) => {
  return (intValue / 100).toFixed(2);
};
export const getCurrencyIntAmount = (decValue) => {
  return Math.round(decValue * 100);
};

// data converters
export const dataUrlToFile = (dataUrl, filename = "image.jpg") => {
  try {
    const [header, base64] = dataUrl.split(",");
    if (!base64) throw new Error("Invalid data URL");

    const mimeMatch = header.match(/data:(.*?);base64/);
    const mime = mimeMatch ? mimeMatch[1] : "application/octet-stream";

    const binary = atob(base64);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);

    return new File([bytes], filename, { type: mime });
  } catch (error) {
    const logCapture = { dataUrl, error };
    serviceLogError("dataUrlToFile", logCapture);
    return new File([], filename, { type: "application/octet-stream" });
  }
};

// third party tools
export const googleConvertColorId = (colorId) => {
  let id, value;
  id = colorId ? colorId.toString() : "0";
  switch (id) {
    case "1":
      value = "#A4BDFC";
      break;
    case "2":
      value = "#7AE7BF";
      break;
    case "3":
      value = "#DBADFF";
      break;
    case "4":
      value = "#FF887C";
      break;
    case "5":
      value = "#FBD75B";
      break;
    case "6":
      value = "#FFB878";
      break;
    case "7":
      value = "#46D6DB";
      break;
    case "8":
      value = "#E1E1E1";
      break;
    case "9":
      value = "#5484ED";
      break;
    case "10":
      value = "#51B749";
      break;
    case "11":
      value = "#DC2127";
      break;
    default:
      value = "#000000";
      break;
  }
  return value;
};
